import englishTranslations from './en';
import spanishTranslations from './es';
var translations = {
    en: englishTranslations,
    es: spanishTranslations
};
export default translations;
